import React from "react";
import CodingProfile from "./CodingProfile";
import Certificates from "../About/Certificates";
function Services() {
  return (
    <div className="servicesection">
      <CodingProfile />
      <Certificates />
    </div>
  );
}

export default Services;
